import * as React from "react";

interface ProgressCircleProps {
    height?: number | string;
    width?: number | string;
}

export class ProgressCircle extends React.Component<ProgressCircleProps> {
    public render() {
        return (<svg width={this.props.width} height={this.props.height} viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="46" className="hexagon" />
        </svg>);
    }
}
